import { useGlobals } from '@/hooks';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const getHorizontalScrollPosition = (elementId: string) => {
  const location = useLocation();
  const [positionFloatButton, setPositionFloatButton] = useState<string>('');

  useEffect(() => {
    const getPositionFloatButton = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const windowScreenWidth = window.innerWidth;
      const container = document.getElementById(elementId)?.clientWidth || 1;
      const width = windowScreenWidth / 2;
      const widthContainer = container / 2;
      const positionFloatButton = `${width + widthContainer}px`;
      setPositionFloatButton(positionFloatButton);
    };

    getPositionFloatButton();
  }, [elementId, location]);

  return positionFloatButton;
};

export const getVerticalScrollPosition = () => {
  const { scrollDirection } = useGlobals();
  const [selectedClientBottom, setSelectedClientBottom] = useState(0);
  const [floatButtonToTopBottom, setFloatButtonToTopBottom] = useState(0);

  useEffect(() => {
    const getSelectedClientBottom = async () => {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const navList = document.querySelector('.nav-list');
      setSelectedClientBottom((navList?.clientHeight ?? 0) - 1);

      await new Promise((resolve) => setTimeout(resolve, 1000));
      const selectedClientElement = document.getElementById('selected-client');
      setFloatButtonToTopBottom(selectedClientElement?.clientHeight ?? 0);
    };

    getSelectedClientBottom();
  }, []);

  return scrollDirection !== 'down' ? selectedClientBottom + floatButtonToTopBottom + 10 : floatButtonToTopBottom;
};
